import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-disease-treatment-type.reducer';
import { IMetDiseaseTreatmentType } from 'app/shared/model/met-disease-treatment-type.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetDiseaseTreatmentType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metDiseaseTreatmentTypeList = useAppSelector(state => state.metDiseaseTreatmentType.entities);
  const loading = useAppSelector(state => state.metDiseaseTreatmentType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-disease-treatment-type-heading" data-cy="MetDiseaseTreatmentTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.home.title">Met Disease Treatment Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.home.createLabel">
              Create new Met Disease Treatment Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metDiseaseTreatmentTypeList && metDiseaseTreatmentTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metDiseaseTreatmentTypeList.map((metDiseaseTreatmentType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metDiseaseTreatmentType.id}`} color="link" size="sm">
                      {metDiseaseTreatmentType.id}
                    </Button>
                  </td>
                  <td>{metDiseaseTreatmentType.code}</td>
                  <td>{metDiseaseTreatmentType.name}</td>
                  <td>{metDiseaseTreatmentType.nameAr}</td>
                  <td>{metDiseaseTreatmentType.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metDiseaseTreatmentType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDiseaseTreatmentType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDiseaseTreatmentType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDiseaseTreatmentType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metDiseaseTreatmentType.home.notFound">
                No Met Disease Treatment Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetDiseaseTreatmentType;
